module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbcf9180e8816925152134cd8a374a7de.bcf9180e.png";